import "./toggle.css";
import { ToggleProps } from "./toggle.props";

const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  text,
}) => {
  return (
    <div className="toggle-wrapper">
      <button
        className={`toggle-container ${checked ? "on" : "off"} ${
          text?.length ? "spacer" : ""
        }`}
        onClick={(e) => {
          e.preventDefault();
          onChange(!checked);
        }}
        defaultChecked={checked}
        disabled={disabled}
      >
        <div className="toggle-circle" />
      </button>
      {text && <span className="toggle-text">{text}</span>}
    </div>
  );
};

export default Toggle;
